import React from 'react';
import PropTypes from 'prop-types';

import { FloatGroup, Input, FlexBinaryChoiceRow, FormCardSpaced, ColorPickerInput } from 'modules/common';
import { WinRedSelect } from '../../form';

const ANIMATION_STYLE_OPTIONS = [
  { label: 'Bounce', value: 'BOUNCE' },
  { label: 'Flash', value: 'FLASH' },
  { label: 'Pulse', value: 'PULSE' },
  { label: 'Rubber Band', value: 'RUBBERBAND' },
  { label: 'Shake X', value: 'SHAKEX' },
  { label: 'Shake Y', value: 'SHAKEY' },
  { label: 'Head Shake', value: 'HEADSHAKE' },
  { label: 'Swing', value: 'SWING' },
  { label: 'Tada', value: 'TADA' },
  { label: 'Wobble', value: 'WOBBLE' },
  { label: 'Jello', value: 'JELLO' },
  { label: 'Heart Beat', value: 'HEARTBEAT' },
];

const ANIMATION_DURATION_OPTIONS = [
  { label: 'Normal', value: 'NORMAL' },
  { label: 'Fast (800ms)', value: 'FAST' },
  { label: 'Faster (500ms)', value: 'FASTER' },
  { label: 'Slow (2s)', value: 'SLOW' },
  { label: 'Slower (3s)', value: 'SLOWER' },
];

function WidgetAcceptAnimation({ widget, updateWidget, upsellType, disabled = false }) {
  const animationStyleValue = ANIMATION_STYLE_OPTIONS.find(opt => opt.value === widget.acceptButtonAnimationStyle);
  const animationDurationValue = ANIMATION_DURATION_OPTIONS.find(
    opt => opt.value === widget.acceptButtonAnimationDuration
  );

  return (
    <div className="widget-button-animation">
      <div>{upsellType}</div>

      <WinRedSelect
        label="Animation Style"
        floatLabel="Animation Style"
        placeholder="Select Animation Style..."
        name="acceptButtonAnimationStyle"
        onChange={updateWidget}
        disabled={disabled}
        value={animationStyleValue}
        options={ANIMATION_STYLE_OPTIONS}
        validators={['required']}
        errorMessages={['Animation Style is required.']}
      />

      <FormCardSpaced
        className="mb-3"
        classNameFooter="pb-1 widget-button-animation_footer"
        footer={
          widget.acceptButtonAnimationRepeat ? (
            <FloatGroup>
              <Input
                type="text"
                disabled={disabled}
                placeholder="Pause Between Animations (Seconds)"
                name="acceptButtonAnimationRepeatAfter"
                value={widget.acceptButtonAnimationRepeatAfter}
                onChange={updateWidget}
                max={25}
                numbersOnly
                description="The amount of time between each animation cycle when it is looped (Max 25 seconds)."
              />
            </FloatGroup>
          ) : null
        }
      >
        <FlexBinaryChoiceRow
          name="acceptButtonAnimationRepeat"
          title="Loop Animation"
          disabled={disabled}
          subTitle="Repeat the animation."
          value={widget.acceptButtonAnimationRepeat}
          onChange={updateWidget}
        />
      </FormCardSpaced>

      <FloatGroup>
        <Input
          type="text"
          placeholder="Animation Delay (Seconds)"
          name="acceptButtonAnimationDelay"
          value={widget.acceptButtonAnimationDelay}
          onChange={updateWidget}
          disabled={disabled}
          max={5}
          numbersOnly
          description="The amount of time before the animation happens after the page is loaded (Max 5 seconds)."
        />
      </FloatGroup>

      <WinRedSelect
        label="Animation Duration"
        floatLabel="Animation Duration"
        placeholder="Select Animation Duration..."
        name="acceptButtonAnimationDuration"
        onChange={updateWidget}
        disabled={disabled}
        value={animationDurationValue}
        options={ANIMATION_DURATION_OPTIONS}
        validators={['required']}
        errorMessages={['Animation Speed is required.']}
        description="The speed of the animation for your button."
      />

      <ColorPickerInput
        value={widget.acceptButtonAnimationColor}
        name="acceptButtonAnimationColor"
        setColorAction={updateWidget}
        disabled={disabled}
        placeholder="Animated Button Color"
        label="Animated Button Color"
        description="Select a color for the animated button."
      />
    </div>
  );
}

WidgetAcceptAnimation.propTypes = {
  widget: PropTypes.object.isRequired,
  updateWidget: PropTypes.func.isRequired,
  upsellType: PropTypes.string,
};

export default WidgetAcceptAnimation;
